import { Link } from 'react-router-dom';
import common from '@/mocks/zh/common';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/90">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                开
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                {common.siteName}
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {common.footer.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              {common.footer.quickLinks}
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  {common.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  {common.nav.categories}
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  {common.nav.articles}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  {common.nav.about}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              {common.footer.contactUs}
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5 text-sm" />
                <div>
                  <span className="block text-xs text-background-50/50">{common.footer.hotline}</span>
                  <span className="text-sm text-background-50/80">400-XXX-XXXX</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5 text-sm" />
                <div>
                  <span className="block text-xs text-background-50/50">{common.footer.email}</span>
                  <span className="text-sm text-background-50/80">support@kaiyun.com</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5 text-sm" />
                <div>
                  <span className="block text-xs text-background-50/50">{common.footer.address}</span>
                  <span className="text-sm text-background-50/80">{common.footer.addressValue}</span>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              服务保障
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-checkbox-circle-line text-accent-400" />
                7×24小时在线客服
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-checkbox-circle-line text-accent-400" />
                多重安全防护
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-checkbox-circle-line text-accent-400" />
                数据加密传输
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-checkbox-circle-line text-accent-400" />
                快速响应机制
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-background-50/40">{common.footer.copyright}</span>
          <div className="flex items-center gap-6">
            <a href="/privacy" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              {common.footer.privacy}
            </a>
            <a href="/terms" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              {common.footer.terms}
            </a>
            <a href="/sitemap" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              {common.footer.sitemap}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}